// @flow

import React, { Fragment } from 'react';

import { Wrapper, Headline, Copy, SessionScore, ScoreExplainer } from './styles';

type SessionReportDetailsPropsType = {
  sessionReportBody: ?string,
  sessionReportRating: ?number,
  internalNotes: ?string,
  showSessionReportRating: boolean,
};

const SessionsViewReportDetails = ({
  sessionReportRating,
  sessionReportBody,
  internalNotes,
  showSessionReportRating,
}: SessionReportDetailsPropsType) => (
  <Wrapper>
    <Headline>Session Rating</Headline>
    {showSessionReportRating && sessionReportRating ? (
      <Fragment>
        <SessionScore>
          {sessionReportRating}
          /5
        </SessionScore>
        <ScoreExplainer>1 = Poor, 5 = Excellent</ScoreExplainer>
      </Fragment>
    ) : (
      <Copy>n/a</Copy>
    )}
    <Headline>Session Report</Headline>
    <Copy>{sessionReportBody || 'n/a'}</Copy>
    <Headline>Internal Notes</Headline>
    <Copy>{internalNotes || 'n/a'}</Copy>
  </Wrapper>
);

export default SessionsViewReportDetails;



// WEBPACK FOOTER //
// ./src/components/sessions/view/report-details/index.js